
import QRCode from 'qrcodejs2'
// 创建一个二维码
/**
 * 
 * @param {String} el  // dom id
 * @param {Object} config // QRCode Config
 */
export function createQrcode (el,config){
  const defaultEl = 'qrcode'
  const defaultConfig = {
    text: '',
    width: 220,
    height: 220
  }
  const qrcode = new QRCode(el || defaultEl, Object.assign({},defaultConfig,config))
  return qrcode  
}